// firebase analytics
import { firebaseEvents } from "./firebase";
import { FIREBASE_EVENT_PROPERTIES } from "constants/constants";

const sendLog = (name: string) => {
  let firebaseRequest: any = {
    [FIREBASE_EVENT_PROPERTIES.EVENT_NAME]: name,
    [FIREBASE_EVENT_PROPERTIES.WALLET_NAME]: null,
    [FIREBASE_EVENT_PROPERTIES.WALLET_ADDRESS]: null,
  };
  firebaseEvents(firebaseRequest);
};
const getSidenav = () => {
  return [
    {
      title: "Hedera",
      iconKey: "hedera",
      path: "/lt",
      subLink: [
        {
          title: "Stake",
          link: "/lt/hedera",
          trackEvent: () => sendLog("Hederapage"),
        },
        {
          title: "DeFi",
          link: "/lt/defi",
          trackEvent: () => sendLog("Defipage"),
        },
      ],
    },
  ];
};

const getLiquidStakingOptions = () => [
  {
    key: "polygon",
    title: "Polygon",
    link: "https://staderlabs.com/polygon",
  },
  {
    key: "fantom",
    title: "Fantom",
    link: "https://fantom.staderlabs.com/liquid-staking/pools",
  },
  {
    key: "bnb",
    title: "BNB",
    link: "https://bnbchain.staderlabs.com/liquid-staking/bnbx",
  },
  {
    key: "near",
    title: "Near",
    link: "https://near.staderlabs.com/",
  },
  {
    key: "terra",
    title: "Terra",
    link: "https://terra.staderlabs.com/liquid-staking",
  },
];

const getSidenavFooter = () => {
  return [
    {
      title: `Theme`,
      key: "theme",
    },
    {
      title: "FAQs",
      key: "faq",
      link: "https://docs-new.staderlabs.com/intro",
      onClick: () => {
        sendLog("FAQ");
      },
    },
    {
      title: `Support`,
      key: "support",
      link: "https://t.me/StaderLabs_Hedera_Official",
      onClick: () => sendLog("Support"),
    },
  ];
};

export { getSidenav, getSidenavFooter, getLiquidStakingOptions };
